import { ref } from "vue";

// 暂时用vant的loading，pc的native-ui的loading效果不好
export function useLoading() {
	const loading = ref(null);

	// 启动 loading
	const startLoading = (message = "") => {
		if (loading.value) {
			loading.value.close();
		}
		loading.value = showLoadingToast({
			message,
			forbidClick: true, //禁用背景点击
			duration: 0, //值为 0 时，toast 不会消失
		});
	};

	// 停止 loading
	const stopLoading = () => {
		if (loading.value) {
			loading.value.close();
			loading.value = null;
		}
	};

	return {
		startLoading,
		stopLoading,
	};
}
